import { apiPost } from '@/lib/api-client';

export async function changePassword(formData: any) {
  return apiPost<{ success: boolean; error?: string }>('/api/auth/change-password', formData);
}

export async function getAdminStats() {
  try {
    const res = await fetch('/api/public/admin/stats');
    return res.json();
  } catch {
    return { people: 0, services: 0, insights: 0, careers: 0, messages: 0 };
  }
}
